/* Contact Details Block JS File */
$(document).ready(function() {

});
